
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import 'viewer/dist/viewer.css';
import Viewer from 'viewer';
import axios from 'axios';
import { message } from 'antd';
import OCR from '../../../../../components/OCR/index.js';
import TicketVerify from '../../../../../components/TicketVerify/index.js';
import './style.scss'

// 照片取证
class CarPicturesList extends Component {
    constructor(props) {
        super(props)
    }
    previewList = [];
    imgRef = React.createRef();

    componentDidUpdate(prevProps) {
        console.debug('componentDidUpdate')
        const { carPictures } = this.props;
        if (prevProps.carPictures.length !== carPictures.length) {
            var elem = document.getElementsByClassName('car-pictures-list')[0];
            if (elem) {
                elem.scrollTop = elem.scrollHeight;
            }
        }
    }

    rotateImage = (data) => {
        return new Promise((resolve, reject) => {
            axios({
                method: 'put',
                url: `/api/lossAss/utils/rotate`,
                data,
            }).then((res) => {
                if (res.data.errCode === 0) {
                } else {
                    message.error(res.data.errInfo);
                }
                resolve();
            })
                .catch((err) => {
                    reject();
                });
        });
    };

    componentDidMount() {
        console.debug('componentDidMount')
        window.addEventListener('message', this.receiveMessage, false);
    }

    componentWillUnmount() {
        // worker.port.onmessage = null;
        window.removeEventListener('message', this.receiveMessage, false);
        this.gallery  && this.gallery.destroy();
    }

    hideViewer = () => {
        this.gallery.hide();
    }
    onSuccess = () => {
        this.props.actions.getCurrentReport(this.props.flowId, this.props.currentAgent._id);
    }
    appendExtraToolIcon = () => {
        const { lossers, flowId, currentAgent, carPictures } = this.props;
        const permissions = currentAgent?.orgAccount?.permissions || [];
        const toolbarDom = document.querySelector('.viewer-toolbar');
        let extraDom = null;
        if (document.querySelector('.viewer-toolbar-extra')) {
            extraDom = document.querySelector('.viewer-toolbar-extra')
        } else {
            extraDom = document.createElement('div');
            extraDom.className = 'viewer-toolbar-extra';
            toolbarDom.appendChild(extraDom);
        }
        const curImg = this.previewList[this.index];
        // 混合previewList中当前index的数据，和props传过来的图片列表当前index的数据，是因为部分操作会更新图片数据，而在预览时，并不会及时去更新previewList
        const curTicket = {...carPictures[this.index], ...this.previewList[this.index]}
        ReactDOM.render(<React.Fragment>
            <TicketVerify ticket={curTicket} currentAgent={currentAgent} flowId={flowId} onSuccess={this.onSuccess} />
            {
                permissions.includes('ocr') ? <OCR lossers={lossers} flowId={flowId} imageUrl={curImg.sourceUrl} imageId={curImg._id} hideViewer={this.hideViewer} onSuccess={this.onSuccess} /> : null
            }
        </React.Fragment>, extraDom);
    }
    showPreviewPicsModal = (_id) => {
        const _this = this;
        const { tabKey, disabled, carPictures } = this.props;
        const index = carPictures.findIndex((item) => item._id === _id);
        this.previewList = carPictures;
        this.index = index;

        this.gallery && this.gallery.destroy();
        const gallery = new Viewer(this.imgRef.current, {
            className: 'viewer-container' + tabKey,
            viewed: () => {
                // 业务中心不支持
                if (disabled) {
                    return;
                }
                this.appendExtraToolIcon();
            },
            show: function () {
                if (_this.previewList[_this.index].rotate) {
                    gallery.imageData.rotate = _this.previewList[_this.index].rotate;
                }
            },
            hidden: () => {
                this.updateRotate(this.previewList[this.index]);
                const extraDom = document.querySelector('.viewer-toolbar-extra');
                if (extraDom) {
                    extraDom.remove();
                }
            },
            url(image) {
                return image.dataset.src;
            },
            initialViewIndex: this.index,
            toolbar: {
                zoomIn: 4,
                zoomOut: 4,
                prev: async () => {
                    const curIndex = this.index, curPic = this.previewList[curIndex];
                    const prevIndex = curIndex <= 0 ? this.previewList.length - 1 : curIndex - 1, prevPic = this.previewList[prevIndex];
                    this.index = prevIndex;
                    gallery.imageData.rotate = prevPic.rotate;
                    gallery.view(this.index);

                    this.updateRotate(this.previewList[curIndex]);
                    this.record = '';
                },
                play: {
                    show: 4,
                    size: 'large'
                },
                next: async () => {
                    const curIndex = this.index;
                    const nextIndex = (curIndex + 1) % this.previewList.length, nextPic = this.previewList[nextIndex];
                    this.index = nextIndex;
                    gallery.imageData.rotate = nextPic.rotate;
                    gallery.view(this.index);

                    this.updateRotate(this.previewList[curIndex]);
                    this.record = '';
                },
                rotateLeft: false,
                rotateRight: () => {
                    const curPic = this.previewList[this.index], rotate = (curPic.rotate || 0) + 90;
                    gallery.rotateTo(rotate);
                    this.previewList = this.previewList.map((item, index) => String(index) === String(this.index) ? { ...item, rotate } : item);
                }
            }
        });
        this.gallery = gallery;
        this.gallery.show();
    }

    updateRotate = (curPic) => {
        const { flowId, tabKey, setPhotos, carPictures } = this.props;
        if (curPic.rotate !== curPic.originalRotate) {
            let curRotate = curPic.rotate % 360;
            this.rotateImage({
                flowId,
                rotate: isNaN(curRotate) ? 0 : parseInt(curRotate),
                imgId: curPic._id,
                imgUrl: curPic.sourceUrl
            }).then(() => {
                this.previewList = this.previewList.map(item => item._id === curPic._id ? { ...curPic, originalRotate: curPic.rotate } : item);
                // 修改父组件数据
                setPhotos(tabKey, carPictures.map(item => item._id === curPic._id ? ({ ...item, rotate: curPic.rotate, originalRotate: curPic.rotate }) : item));
            });
        }
    }

    receiveMessage = async (event) => {
        // window.removeEventListener("message", this.receiveMessage, false);
        const { actions, flowId } = this.props;
        const data = event.data;
        if (data.eventName === 'refreshReport') {
            // 重新获取工单详情
            await actions.getCurrentReport(flowId);

            window.removeEventListener('message', this.receiveMessage, false);
            setTimeout(() => {
                window.addEventListener('message', this.receiveMessage, false);
            }, 1000);
        }
    };
 
    
    render() {
        const {
            selectedState,
            handelSelectPicture,
            handelCancelPicture,
            tabKey,
            disabled,
            carPictures
        } = this.props;

        return (
            <div className="car-pictures-list" id={tabKey + '-list'} style={this.props.style}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }} ref={this.imgRef}>
                    {
                        carPictures.map(picture => {
                            const isSelected = selectedState && selectedState.includes(picture._id);
                            return <div className={`car-loss-pics-select ${isSelected ? 'on' : ''} ${disabled ? 'disabled' : ''}`} data-id={picture._id} key={picture._id}>
                                {
                                    !disabled ? isSelected ? <span
                                        className="on-mouse-move"
                                        onClick={(event) => handelCancelPicture(event, picture._id)}
                                    >
                                        <i className="iconfont icon-checked on-mouse-move-check-circle" />
                                    </span> : <span
                                        className="on-mouse-move"
                                        onClick={(event) => handelSelectPicture(event, picture._id)}
                                    >
                                        <i className="iconfont icon-checked on-mouse-move-check-circle-o" />
                                    </span> : null
                                }
                                <div className="img">
                                    <img
                                        data-id={picture._id}
                                        data-src={picture.sourceUrl}
                                        onClick={() => this.showPreviewPicsModal(picture._id)}
                                        src={picture.thumbnail_url}
                                        alt=""
                                        style={{ transform: `rotate(${picture.rotate || 0}deg)` }}
                                    />
                                    <p className="img-mark">
                                        {
                                            (picture.ticketVerify === 'ps' || picture.ticketVerify === 'fake') ? <i className="fail-mark" /> : null
                                        }
                                        {
                                            picture.ticketVerify === 'real' ? <i className="success-mark" /> : null
                                        }
                                        {
                                            picture.referer === 'agent' ? <i className="iconfont icon-local" /> : null
                                        }
                                    </p>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        );
    }
}

export default CarPicturesList;
